import React from 'react';
import { Link } from 'react-router-dom';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { FontIcon } from './FontIcon';
import type { Breadcrumb as Interface } from '../../design/components';

/**
 * Breadcrumb - MUI implementation
 * Shows: Home icon > crumbs[0] > crumbs[1] > ...
 */
export const Breadcrumb: React.FC<Interface> = ({ crumbs = [] }) => {
  // Capitalize first letter for display
  const formatName = (name: string) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Build path for each crumb
  const buildPath = (index: number) => '/' + crumbs.slice(0, index + 1).join('/');

  return (
    <MuiBreadcrumbs aria-label="breadcrumb" sx={{ fontSize: '0.875rem' }}>
      {crumbs.length === 0 ? (
        <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
          <FontIcon name="Home" size="small" style={{ marginRight: '4px' }} />
          Home
        </Typography>
      ) : (
        <MuiLink
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          <FontIcon name="Home" size="small" style={{ marginRight: '4px' }} />
          Home
        </MuiLink>
      )}

      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        const isModel = index === 0;

        return isLast ? (
          <Typography key={index} color="text.primary" sx={{ fontWeight: 500 }}>
            {isModel ? formatName(crumb) : crumb}
          </Typography>
        ) : (
          <MuiLink
            key={index}
            component={Link}
            to={buildPath(index)}
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {isModel ? formatName(crumb) : crumb}
          </MuiLink>
        );
      })}
    </MuiBreadcrumbs>
  );
};
